import { render, staticRenderFns } from "./Paths.vue?vue&type=template&id=56096bb9&scoped=true&"
import script from "./Paths.vue?vue&type=script&lang=js&"
export * from "./Paths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56096bb9",
  null
  
)

export default component.exports